/**
 * @format
 */
import { ExchangeRatesService } from '@/scripts/services/exchange-rates/exchange-rates-service';

export const CurrencyMixin = {
    data() {
        return {
            currenciesEnum: {
                USD: 'USD',
                EUR: 'EUR',
                JPY: 'JPY',
                GBP: 'GBP',
                CNY: 'CNY',
                AUD: 'AUD',
                CAD: 'CAD',
                CHF: 'CHF',
                HKD: 'HKD',
                NZD: 'NZD',
            },
            currencyNumberFormatter: new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }),
        };
    },

    methods: {
        getFlag(value) {
            switch (value) {
                case this.currenciesEnum.USD:
                    return { flag: 'US', symbol: '$' };
                case this.currenciesEnum.EUR:
                    return { flag: 'EU', symbol: '€  ' };
                case this.currenciesEnum.JPY:
                    return { flag: 'JP', symbol: '¥' };
                case this.currenciesEnum.GBP:
                    return { flag: 'GB', symbol: '£' };
                case this.currenciesEnum.CNY:
                    return { flag: 'CN', symbol: '¥' };
                case this.currenciesEnum.AUD:
                    return { flag: 'AU', symbol: '$' };
                case this.currenciesEnum.CAD:
                    return { flag: 'CA', symbol: '$' };
                case this.currenciesEnum.CHF:
                    return { flag: 'CH', symbol: '₣' };
                case this.currenciesEnum.HKD:
                    return { flag: 'HK', symbol: '$' };
                case this.currenciesEnum.NZD:
                    return { flag: 'NZ', symbol: '$' };
                default:
                    break;
            }
        },

        getCurrencyConversion(payload) {
            return new Promise((resolve, reject) => {
                ExchangeRatesService.post(payload)
                    .then(({ data }) => resolve(data))
                    .catch(reject);
            });
        },

        formatCurrency(value, symbol) {
            const abs = Math.abs(Number(value));
            const formattedAbs = this.currencyNumberFormatter.format(abs);
            const formattedAbsWithSymbol = `${symbol}${formattedAbs}`;

            if (value < 0) {
                return `-${formattedAbsWithSymbol}`;
            }

            return formattedAbsWithSymbol;
        },
    },
};
